import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, first, map } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { getHomeFullPath } from '@app/routes-definitions';
import { UserStoreSelectors, UserStoreState } from '@core-lib/store/user-store';

@Injectable({
	providedIn: 'root'
})
export class RouteWithRolesGuard {
	constructor(
		private router: Router,
		private store: Store<UserStoreState.IUserStoreState>
	) {}

	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		if (!next?.data?.authorizedRoles) {
			return of(true);
		}
		return this.store.pipe(
			select(UserStoreSelectors.selectUserRoles),
			filter(roles => !!roles),
			map(roles => {
				const canAccess = roles.some(userRole => next.data.authorizedRoles.includes(userRole));
				if (!canAccess) {
					if (next.data.notAllowedUrl) {
						this.router.navigate([next.data.notAllowedUrl]);
					} else {
						this.router.navigate([getHomeFullPath()]);
					}
				}
				return canAccess;
			}),
			first()
		);
	}
}
